import * as React from "react";
import {PublicUser} from "@models/public-user";
import Table from "@components/public-users/item/UserPurchases/Table";
import {Card} from "antd";
import SearchComponent from "@components/public-users/item/UserPurchases/Search";
import whitListData from "@hocs/withListData";
import api from "@api/public-user";
import withPaginationComponent from "@hocs/withPaginationComponent";



interface PropsFromHoc {
  data          :PublicUser[];
  isFetched     : boolean;
  currentPage   : number;
  search        : (params: object | null) => void;
  onDeleteItem  : (id:string) => void;
}


type AllProps = PropsFromHoc ;

const ListPage: React.FC<AllProps> = (props) => {
  const {data, isFetched, currentPage, search} = props;
  
  return (
    <div>
      <div className={"page-table-wrapper"}>
        <Card className={`page-table-header`} bordered={false}>
          <SearchComponent search={search}/>
        </Card>
        
        <Table
          data={data}
          currentPage={currentPage}
          rowKey={record => record.id}
          loading={!isFetched}
        />
      </div>
    </div>
  );
};


export default whitListData(
  withPaginationComponent(ListPage),
  {
    fetchRequest: api.getUserPurchases,
    paginationOnScroll: false,
  }
);
